<template>
  <div
    class="v-card__wrapper"
    :class="{ [extraClass]: !!extraClass }"
    @click="_onClick"
  >
    <div class="item-logo" :class="{ [id]: true }">
      <div class="item-logo--top">
        <img :src="icon" alt="icon" />
      </div>

      <div class="item-logo--bottom">
        <img :src="iconActive || icon" alt="icon" />
      </div>
    </div>

    <div class="v-card__title">
      {{ title }}
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";

export default Vue.component("VCard", {
  props: {
    id: VueTypes.string,
    title: VueTypes.string,

    // svgs
    icon: VueTypes.string,
    iconActive: VueTypes.string,
    extraClass: VueTypes.string.def("")
  },

  methods: {
    _onClick() {
      this.$emit("click", this.id);
    },

    _toggleHovered() {
      this.hovered = !this.hovered;
    }
  }
});
</script>

<style lang="scss" scoped>
$ns: "v-card";

.#{$ns} {
  &__wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: $white;
    box-shadow: 2px 2px 25px rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    width: 270px;
    height: 140px;
    cursor: pointer;

    .item-logo {
      position: relative;

      &--top,
      &--bottom {
        transition: opacity 0.1s linear;
      }

      img {
        width: 100%;
        height: 100%;
      }

      &--top {
        opacity: 1;
        position: absolute;
      }

      &--bottom {
        opacity: 0;
      }
    }

    &:hover {
      .item-logo {
        &--top {
          opacity: 0;
        }

        &--bottom {
          opacity: 1;
        }
      }

      .#{$ns}__title {
        color: $primary-color;
      }
    }
  }

  &__title {
    font-family: "Lato-Regular", sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 27px;
    transition: color 0.1s linear;
    margin-top: 15px;
    color: $title-text-color;
  }
}
</style>
